import React from "react";
import "./terms.css";

function Financial() {
  return (
    <div className="terms-main">
      <div className="terms-headings-contanier">
        <div className="terms-headings">
          <span> Billing and Refunds</span>
          <span> Policy</span>
        </div>
        <p>Last updated: September 15, 2025</p>
      </div>

      <div className="privacy-policy-container">
        {/* left pillar */}
        <div
          className="pillar pillar-left"
          style={{
            flex: "0 0 7%",
            background: "url('/images/pillars.svg') no-repeat top",
            backgroundSize: "contain",
            height: "auto",
          }}
        ></div>
        <div className="content">
          <div className="terms-grid-view">
            {/* main content */}
            <div className="text-content">
              <p>
                Befisc Private Limited (“us”, “we”, “BeFiSc”) is the owner and
                publisher of the website https://www.befisc.com/, and operates
                any other digital interface through which the Services are
                provided (collectively hereinafter referred to as the
                “Platform”).
                <br />
                <br />
                This Payment and Refund Policy (“Policy”) governs all products
                and services offered by BeFiSc, including subscription-based
                products and one-time purchase products or services. By
                purchasing or subscribing to any BeFiSc product, you agree to
                these terms. We reserve the right to update this policy at any
                time, with changes effective upon posting the revised version on
                our website. Continued use of our products or services after
                changes constitutes acceptance of the updated policy.
                <br />
              </p>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem ",
                  justifyContent: "start",
                }}
              >
                <div className="q-tab">
                  <img
                    src={"/images/question-close-icon.png"}
                    alt=""
                    className="q-tab-icon"
                    loading="lazy"
                    decoding="async"
                  />

                  <span className="q">Objective</span>
                </div>
                <div className="a-tab">
                  <span className="simple-text">
                    As a technology service provider, we place the customer
                    experience at the centre of everything we do. This Policy
                    establishes clear, fair and legally compliant rules for when
                    and when not refunds are available for our software and
                    related services. Specifically, it aims to set transparent
                    expectations by explaining when the fees or statutory taxes
                    already remitted are non-refundable. By articulating these
                    principles up front, the policy reduces ambiguity, minimises
                    disputes and ensures alignment with the Consumer Protection
                    Act 2019.
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem ",
                    justifyContent: "start",
                  }}
                >
                  <div className="q-tab">
                    <img
                      src={"/images/question-close-icon.png"}
                      alt=""
                      className="q-tab-icon"
                      loading="lazy"
                      decoding="async"
                    />

                    <span className="q">Pricing Structure</span>
                  </div>
                  <div className="a-tab">
                    <span className="simple-text">
                      BeFiSc offers a variety of products and services,
                      including subscription-based SaaS solutions and one-time
                      purchase products or services (e.g., software licenses,
                      professional services, or premium features). Prices are
                      listed in US Dollars (USD) or Indian Rupees (INR),
                      depending on your billing location or preference selected
                      at checkout. Prices exclude applicable taxes, fees, or
                      duties, which may be added based on your location or
                      jurisdiction.
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem ",
                    justifyContent: "start",
                  }}
                >
                  <div className="q-tab">
                    <img
                      src={"/images/question-close-icon.png"}
                      alt=""
                      className="q-tab-icon"
                      loading="lazy"
                      decoding="async"
                    />

                    <span className="q">
                      Subscription-Based Products – Pricing & Plans
                    </span>
                  </div>
                  <div className="a-tab">
                    <ContentSection
                      sections={[
                        {
                          heading: "Billing Cycle",
                          content:
                            "Subscriptions are billed monthly or annually in advance, depending on the plan selected, on the anniversary of your subscription start date. Annual plans may offer a discount for upfront payment.",
                        },
                        {
                          heading: "Plan Details",
                          content:
                            "Each product has tiered plans with specific features and usage limits (e.g., credits or API calls). Refer to the product’s pricing page for details on features, pricing, and included resources.",
                        },
                      ]}
                    />
                    <div className="section-item">
                      <h3 className="section-title">Currency Options</h3>
                      <ul
                        style={{
                          position: "relative",
                          right: "1.5rem",
                          display: "flex",
                          flexDirection: "column",
                          gap: ".2rem",
                        }}
                      >
                        {[
                          "USD Pricing: Displayed for users outside India or those selecting USD at checkout.",
                          "INR Pricing: Available for users in India or those selecting INR at checkout. Prices in INR are set based on prevailing exchange rates and may be adjusted periodically to reflect market conditions.",
                        ].map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </div>
                    <ContentSection
                      sections={[
                        {
                          heading: "Overages",
                          content:
                            "Usage  exceeding  the  plan’s  allocated  resources  (e.g.,  credits)  may  incur additional fees at a pay-as-you-go rate specified at the time of purchase, in the currency of your subscription. Unused resources (e.g., credits) typically expire at the end of each billing cycle and are non-transferable unless otherwise stated.",
                        },
                        {
                          heading: "Custom Plans",
                          content:
                            "Enterprise or high-volume plans are available with custom pricing and features  (e.g.,  API  access,  dedicated  support,  or  on-premises  deployment).  Pricing in USD or INR is determined via agreement with our sales team.",
                        },
                        {
                          heading: "Price Changes",
                          content:
                            "We may adjust subscription pricing with at least 30 days’ advance notice via email or in-app notification. If you do not agree to the changes, you may cancel your subscription before the new pricing takes effect.",
                        },
                      ]}
                    />
                  </div>
                </div>
                {/* one component  */}
                <div className="q-tab">
                  <img
                    src={"/images/question-close-icon.png"}
                    alt=""
                    className="q-tab-icon"
                    loading="lazy"
                    decoding="async"
                  />
                  <span className="q">
                    One-Time Purchase Products – Pricing & Plans
                  </span>
                </div>
                <div className="a-tab">
                  <ContentSection
                    sections={[
                      {
                        heading: "Pricing",
                        content:
                          "One-time purchases (e.g., perpetual licenses, standalone features, or professional services) are charged upfront at the price listed at the time of purchase, in USD or INR based on your selection or billing location.",
                      },
                      {
                        heading: "Non-Recurring",
                        content:
                          "These  purchases  do  not  involve  recurring  fees  unless  paired with a maintenance or support plan, which may have separate terms.",
                      },
                      {
                        heading: "Bundled  Services",
                        content:
                          "Some  one-time  purchases  may  include  limited  access  to subscription-based features (e.g., a one-time license with a trial subscription), subject to the terms of the subscription.",
                      },
                    ]}
                  />
                </div>
                {/* 2nd component */}
                <div className="q-tab">
                  <img
                    src={"/images/question-close-icon.png"}
                    alt=""
                    className="q-tab-icon"
                    loading="lazy"
                    decoding="async"
                  />
                  <span className="q">Billing and Payment Terms</span>
                </div>
                <div className="a-tab">
                  <ContentSection
                    sections={[
                      {
                        heading: "Payment Methods",
                        content:
                          "We accept major credit cards, bank transfers (for Enterprise plans), UPI (for INR payments), and other payment methods as displayed during checkout. You authorize  BeFiSc  to  charge  your  selected  payment  method  for  all  applicable  fees, including subscriptions, one-time purchases, overages, and taxes. ",
                      },
                      {
                        heading: "Currency Handling",
                        content:
                          "Payments are processed in the currency selected at checkout (USD or  INR).  If  your  payment  method  is  in  a  different  currency,  your  bank  or  payment provider may apply conversion fees, for which you are responsible. ",
                      },
                      {
                        heading: "Taxes",
                        content:
                          "You are responsible for all applicable sales, use, value-added, GST, or other taxes. We  will  collect  taxes  where required by law, displayed in USD or INR based on your billing currency.",
                      },
                      {
                        heading: "Failed Payments",
                        content:
                          "If a payment fails, we may suspend access to the product or service until resolved. Late payments may incur fees as permitted by law.",
                      },
                      {
                        heading: "Invoices",
                        content:
                          "For  Enterprise  plans  or  one-time  purchases,  invoices are issued in USD or INR upon purchase or as agreed. Payment is due within the timeframe specified on the invoice (typically 30 days). ",
                      },
                    ]}
                  />
                </div>

                {/* 3rd component */}
                <div className="q-tab">
                  <img
                    src={"/images/question-close-icon.png"}
                    alt=""
                    className="q-tab-icon"
                    loading="lazy"
                    decoding="async"
                  />
                  <span className="q">
                    Subscription-Based Products – Refund & Cancellation
                  </span>
                </div>
                <div className="a-tab">
                  <ContentSection
                    sections={[
                      {
                        heading: "No  Refunds  for  Subscriptions",
                        content:
                          "Subscription  fees  are  non-refundable,  except  as required  by  applicable  consumer  protection  laws.  This  includes  monthly  or  annual subscriptions, renewals, and overage fees.",
                      },
                      {
                        heading: "Trial Periods",
                        content:
                          "If a free trial is offered, no payment is required during the trial. Upon trial expiration, your subscription will convert to a paid plan unless cancelled. Trial usage does not qualify for refunds. ",
                      },
                      {
                        heading: "Cancellation",
                        content:
                          "You may cancel your subscription at any time via your account dashboard. Upon  cancellation,  access continues until the end of the current billing cycle, with no pro-rated refunds for unused portions of the billing period.",
                      },
                      {
                        heading: "Failed Payments",
                        content:
                          "If a payment fails, we may suspend access to the product or service until resolved. Late payments may incur fees as permitted by law.",
                      },
                      {
                        heading: "Invoices",
                        content:
                          "For  Enterprise  plans  or  one-time  purchases,  invoices are issued in USD or INR upon purchase or as agreed. Payment is due within the timeframe specified on the invoice (typically 30 days). ",
                      },
                    ]}
                  />
                  <div className="section-item">
                    <h3 className="section-title">Exceptions</h3>
                    <span className="simple-text">
                      Refunds may be considered at BeFiSc’s sole discretion in
                      exceptional cases, such as
                    </span>
                    <ul
                      style={{
                        position: "relative",
                        right: "1.5rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: ".2rem",
                      }}
                    >
                      {[
                        "Technical  issues  solely  attributable  to  BeFiSc  that  prevent  use  of  the  service, verified within 7 days of the issue.",
                        "Erroneous charges due to billing errors, reported within 30 days of the charge. Refunds, if approved, will be issued in the original currency (USD or INR) and form of payment.",
                      ].map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* section two */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem ",
                  justifyContent: "start",
                  marginTop: "2rem",
                }}
              >
                <div className="q-tab">
                  <img
                    src={"/images/question-close-icon.png"}
                    alt=""
                    className="q-tab-icon"
                    loading="lazy"
                    decoding="async"
                  />
                  <span className="q">
                    One-Time Purchase Products – Refund & Cancellation
                  </span>
                </div>
                <div className="a-tab">
                  <div className="section-item">
                    <h3 className="section-title">
                      Limited Refund Eligibility
                    </h3>
                    <span className="simple-text">
                      Refunds may be considered at BeFiSc’s sole discretion in
                      exceptional cases, such as
                    </span>
                    <ul
                      style={{
                        position: "relative",
                        right: "1.5rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: ".2rem",
                      }}
                    >
                      {[
                        "Non-Delivery: Failure to deliver the purchased product or service (e.g., software license or professional service) within the agreed timeframe.",
                        "Defective Product: Technical defects solely attributable to BeFiSc, reported and verified within 7 days of purchase. ",
                      ].map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="section-item">
                    <h3 className="section-title">
                      Non-Refundable Situations:
                    </h3>
                    <ul
                      style={{
                        position: "relative",
                        right: "1.5rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: ".2rem",
                      }}
                    >
                      {[
                        "Buyer’s remorse or change of mind.",
                        "Use  of  the  product  or  service  (e.g.,  activation of a license or completion of a service).",
                        "Purchases  bundled  with  non-refunded  services  (e.g.,  setup  or  implementation fees).",
                      ].map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                    <ContentSection
                      sections={[
                        {
                          heading: "Evaluation Periods",
                          content:
                            "Where applicable, we may provide trial access, demos, or previews for one-time purchase products to help you evaluate suitability before purchase. Usage during such periods does not qualify for refunds.",
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
              {/* section three */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem ",
                  justifyContent: "start",
                  marginTop: "2rem",
                }}
              >
                <div className="q-tab">
                  <img
                    src={"/images/question-close-icon.png"}
                    alt=""
                    className="q-tab-icon"
                    loading="lazy"
                    decoding="async"
                  />

                  <span className="q">Exceptions and Disputes</span>
                </div>
                <div className="a-tab">
                  <ContentSection
                    sections={[
                      {
                        heading: "Exceptions",
                        content:
                          "Refunds  outside  this  policy  may  be  granted  at  BeFiSc’s  discretion  for significant technical issues or billing errors, provided they are reported promptly (within 7 days for technical issues or 30 days for billing disputes).",
                      },
                      {
                        heading: "Disputes",
                        content:
                          "If  you  believe  a charge was made in error, notify us within 30 days of the charge  date  for  investigation.  All  disputes  are  governed  by  the  laws  of  India.  You irrevocably consent to the exclusive jurisdiction of courts at New Delhi for all disputes arising out of or relating to this Policy.",
                      },
                      {
                        heading: "Account  Termination",
                        content:
                          "If  we terminate your account for violating our Terms of Use (e.g., misuse, fraud, or unauthorized access), no refunds will be issued, and you remain responsible for outstanding fees.",
                      },
                    ]}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem ",
                  justifyContent: "start",
                  marginTop: "2rem",
                }}
              >
                <div className="q-tab">
                  <img
                    src={"/images/question-close-icon.png"}
                    alt=""
                    className="q-tab-icon"
                    loading="lazy"
                    decoding="async"
                  />

                  <span className="q">Additional Terms</span>
                </div>
                <div className="a-tab">
                  <ContentSection
                    sections={[
                      {
                        heading: "Force  Majeure",
                        content:
                          "BeFiSc  is  not  liable  for  delays or failures to provide services due to events beyond our control (e.g., natural disasters, cyberattacks, or regulatory changes). No refunds will be issued in such cases.",
                      },
                      {
                        heading: "Third-Party  Purchases",
                        content:
                          "Products  or  services  purchased  through  resellers  or  third parties are subject to their refund policies.",
                      },
                      {
                        heading: "Currency  Fluctuations",
                        content:
                          "For  INR  payments,  prices  may  be  adjusted  periodically  to reflect exchange rate changes. Such adjustments will be communicated with at least 30 days’ notice.",
                      },
                    ]}
                  />
                </div>
              </div>
              <p>
                In case any query/dispute/grievance remains unresolved after 15
                days from the date it was first logged, you may escalate the
                matter by writing to our grievance officer at{" "}
                <b>legal@befisc.com</b>, who will conduct a final review and
                respond within 15 working days.
              </p>
            </div>
          </div>
        </div>
        {/* right pillar */}
        <div
          className="pillar pillar-left"
          style={{
            flex: "0 0 7%",
            background: "url('/images/pillars.svg') no-repeat top",
            backgroundSize: "contain",
            height: "auto",
          }}
        ></div>
      </div>
    </div>
  );
}

export default Financial;
const ContentSection = ({ sections }) => {
  return (
    <>
      {sections.map((section, index) => (
        <div key={index} className="section-item">
          <h3 className="section-title">{section.heading}</h3>
          <p className="section-content">{section.content}</p>
        </div>
      ))}
    </>
  );
};
function QuestionsTab({ ques, ans }) {
  return (
    <div className="flexprop" style={{ gap: "20px" }}>
      <div className="q-tab">
        <img
          src={"/images/question-close-icon.png"}
          alt=""
          className={"q-tab-icon"}
          loading="lazy"
          decoding="async"
        />

        <span className="q">{ques}</span>
      </div>
      <div className="a-tab">{ans}</div>
    </div>
  );
}
